/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IObrienHomeData } from './obrien-home.data';
import { IObrienHomeProps } from './obrien-home.props.autogenerated';

export interface IObrienHomeViewProps extends IObrienHomeProps<IObrienHomeData> {
    obHeroTitle: string;
    obHeroImage: string;
    obHeroId: string;
    obHeroContent: string;
    obHeroButtonLink: string;
    obHeroButtonText: string;
}

/**
 *
 * ObrienProductHeader component
 * @extends {React.PureComponent<IObrienProductHeaderProps<IObrienProductHeaderData>>}
 */
class ObrienHome extends React.PureComponent<IObrienHomeProps<IObrienHomeData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const HeroTitle = config.obHeroTitle ? config.obHeroTitle : 'No Header Name Provided';
        const HeroImage = config.obHeroImage ? config.obHeroImage.src : '';
        const HeroId = config.obHeroId ? config.obHeroId : 'No Id';
        const HeroContent = config.obHeroContent ? config.obHeroContent : 'No Content';
        const HeroButtonLink = config.obHeroButtonLink ? config.obHeroButtonLink : 'No Link';
        const HeroButtonText = config.obHeroButtonText ? config.obHeroButtonText : 'No Text';
        const ObrienHomeViewProps = {
            ...this.props,
            obHeroTitle: HeroTitle,
            obHeroImage: HeroImage,
            obHeroId: HeroId,
            obHeroContent: HeroContent,
            obHeroButtonLink: HeroButtonLink,
            obHeroButtonText: HeroButtonText
        };
        return this.props.renderView(ObrienHomeViewProps);
    }
}

export default ObrienHome;
